import AxiosPromotion from '.';
import config from '../../config';
import { OrderPayment } from '../../model/OrderPayment.model';

export const CreateOrders = async (cartId, uid, isInstallment, params = { enableWarning: false }) => {
  const body = { cartId, uid, isInstallment };
  const response = await AxiosPromotion.post(
    `${config.API_URL}/promotion/payment/orders`,
    body,
    { params }
  );
  const { success, data, error } = response?.data;
  if (!success) {
    return new OrderPayment(error[0]);
  }
  return new OrderPayment(data);
};

export const PlaceOrders = async (cartId, uid) => {
  const body = { cartId, uid };
  const response = await AxiosPromotion.post(
    `${config.API_URL}/renewal/place/orders`,
    body,
  );
  return new OrderPayment(response?.data);
};

export const PaymentConfirmation = async (paymentData) => {
  const { lineMid, amwayNumber, feature, orderId, success } = paymentData;
  //! remark expand payment data in this function
  const body = { uid: lineMid, amwayNumber, orderId, success };
  const { data } = await AxiosPromotion.post(
    `${config.API_URL}/promotion/payment/confirmation`,
    body,
  );
  return data;
};
